import {Repo} from "@services/repos/vendors/repo";
import {AxiosPromise} from "axios";

export class AdminRoleRepo extends Repo{
  constructor() {
    super('AdminRole');
  }

  getAllPermissions(): AxiosPromise {
    return this.http.get(this.getPath('get-all-permissions'));
  }

  getAwailablePermissions(): AxiosPromise {
    return this.http.get(this.getPath('get-awailable-permissions'));
  }

  getUsers(): AxiosPromise {
    return this.http.get(this.getPath("get-users"));
  }

  getList(): AxiosPromise {
    return this.http.get(this.getPath("get-list"));
  }

  get(id: string): AxiosPromise {
    return this.http.get(this.getPath("get"), this.convertToUrlParams({ id }));
  }


  createLimit(query: any): AxiosPromise {
    query = {
      ...query,
      ...this.getDefaultQuery()
    };
    return this.http.post(this.getPath('create-limit-setting'), query);
  }

  resetFees(userId: string): AxiosPromise {
    return this.http.get(this.getPath("reset-fees"), this.convertToUrlParams({userId}));
  }

  resetLimits(userId: string): AxiosPromise {
    return this.http.get(this.getPath("reset-limit-settings"), this.convertToUrlParams({userId}));
  }

  create(query: any): AxiosPromise {
    query = {
      ...query,
      ...this.getDefaultQuery()
    };
    return this.http.post(this.getPath("create"), query);
  }

  update(query: any): AxiosPromise {
    query = {
      ...query,
      ...this.getDefaultQuery()
    };
    return this.http.post(this.getPath("update"), query);
  }

  delete(id: string): AxiosPromise {
    return this.http.post(this.getPath(`delete?id=${id}`), );
  }
}
